import type { RepeatPeriodValue } from '@elfsight/widget-conditional-display';
import { DAY_MAP } from './constants';

export const buildBasicRRule = (
  period: Exclude<RepeatPeriodValue, 'noRepeat' | 'custom'>,
  start: Date
) => {
  if (period === 'daily') {
    return ['FREQ=DAILY'];
  }

  if (period === 'weeklyOn') {
    return ['FREQ=WEEKLY', `BYDAY=${DAY_MAP[start.getDay()]}`];
  }

  if (period === 'weekday') {
    return ['FREQ=WEEKLY', `BYDAY=${DAY_MAP.slice(1, 6)}`];
  }

  if (period === 'annuallyOn') {
    return [
      'FREQ=YEARLY',
      `BYMONTH=${start.getMonth() + 1}`,
      `BYMONTHDAY=${start.getDate()}`
    ];
  }

  if (period === 'nthDayInMonth') {
    const weekOfMonth = Math.floor((start.getDate() - 1) / 7) + 1;
    return ['FREQ=MONTHLY', `BYDAY=${weekOfMonth}${DAY_MAP[start.getDay()]}`];
  }

  return ['FREQ=MONTHLY', `BYDAY=-1${DAY_MAP[start.getDay()]}`];
};
